export default __webpack_public_path__ + "static/media/cloudbedFiverrFeedback.0b9088ab.png";